<div class="container center">
    <div class="card">
        <h2>DiTECT</h2>
        <hr />
        <p>
            DiTECT project aims to develop an intelligent tool to manage food safety, in real-time, along the food
            supply
            chain (detection, assessment, and mitigation of biological, chemical and environmental contaminants).
            DiTECT
            project brings together research, industrial and food authority partners representing the agri-food
            industry in
            EU and China. The project aspires to establish the foundation for future food safety monitoring
            platforms with
            the use of Big Data.
        </p>
    </div>
</div>